import {action, Action} from 'easy-peasy';

interface CustomizeFormFieldChoice {
    id: number;
    name: string;
    value: string;
}

interface CustomizeFormFieldChoicesState {
    items: CustomizeFormFieldChoice[];
    loadCustomizeFormFieldChoices: Action<CustomizeFormFieldChoicesState, CustomizeFormFieldChoice[]>;
}

const customizeFormFieldChoices: CustomizeFormFieldChoicesState = {
    items: [],
    loadCustomizeFormFieldChoices: action((state, customizeFormFieldChoicesList) => {
        state.items = customizeFormFieldChoicesList;
    }),
};

export default customizeFormFieldChoices; 